import { render, staticRenderFns } from "./appliedPotential.vue?vue&type=template&id=08b7bc36&scoped=true"
import script from "./appliedPotential.vue?vue&type=script&lang=js"
export * from "./appliedPotential.vue?vue&type=script&lang=js"
import style0 from "./appliedPotential.vue?vue&type=style&index=0&id=08b7bc36&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08b7bc36",
  null
  
)

export default component.exports